import React, { useEffect } from "react";
import { Typography, Box, Chip, Button } from "@mui/material";
import NewBlogCard from "./NewBlogCard";
import { logout, useSiteState } from "../hookState/SiteState";
import { useNavigate } from "react-router-dom";
import { setProfileState } from "../hookState/ProfileState";
import RouteConstants from "../constants/RouteConstant";
import First from "../assets/blog/1.png";
import Second from "../assets/blog/2.png";
import Third from "../assets/blog/3.png";
import ApiHelper from "../utillity/ApiHelper";
import APIURLConstants from "../config/config";

export const NewBlog = () => {
	const state = useSiteState();
	const navigate = useNavigate();
	const handleRedirect = (val) => {
		navigate(RouteConstants.FEED);
	};
	const [feeds, setFeeds] = React.useState([]);
	const [loading, setLoading] = React.useState(true);

	useEffect(() => {
		getFeedDetails();
	}, []);

	const getFeedDetails = () => {
		ApiHelper.get(APIURLConstants.ALL_FEEDS)
			.then((res) => {
				setLoading(false);
				setFeeds(res.data.result.feed);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: { xs: "300px", md: "1280px" },
				zIndex: 3,
				// p: "20px 20px",
				gap: { xs: 0, md: 4 },
				background: "#fff",
				justifyContent: "center",
				alignItems: "center",
				alignSelf: "center",
				alignContent: "center",
				py: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
				}}
			>
				<Chip
					label="Blogs"
					variant="filled"
					sx={{
						borderRadius: 4,
						fontSize: "18px",
						color: "#667085",
						width: "200px",
					}}
				/>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: { xs: "column", md: "row" },
					justifyContent: "space-between",
					p: "20px 20px",
					width: { xs: "300px", md: "1280px" },
					alignItems: "center",
					alignContent: "center",
					alignSelf: "center",
				}}
			>
				<Box>
					<Typography
						fontWeight={600}
						fontSize={{ xs: 30, md: 48 }}
						color="#000000"
					>
						{" Latest Blog Articles"}
					</Typography>
					<Typography
						fontWeight={400}
						fontSize={{ xs: 15, md: 18 }}
						color="#667085"
					>
						{
							"Stay updated with the latest trends, tips, and guides in game modding."
						}
					</Typography>
				</Box>

				<Button
					color="secondary"
					// sx={{ }}
					onClick={() => handleRedirect("login")}
					sx={{
						alignItems: "center",
						justifyContent: "center",
						my: "auto",
						color: "primary.main",
						bgcolor: "tertiary.main",
						px: { xs: 0, md: 2 },
						// mx: { xs: "-5px" },
						borderRadius: 8,
						height: { xs: "23px", md: "32px" },
						minWidth: "46px",
						// width: { xs: "20px" },
					}}
				>
					<Typography
						color={"primary.main"}
						textTransform={"capitalize"}
						fontSize={{ xs: 14, md: 14 }}
						fontWeight={600}
					>
						View All
					</Typography>
				</Button>
			</Box>

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "center",
				}}
			>
				{/* {[1, 2, 3].map(() => {
					return <WhyUsCard description />;
				})} */}

				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: { xs: "column", md: "row" },
						justifyContent: "center",
						width: { xs: "300px", md: "1280px" },
						// gap: 1,
						gap: 2,
					}}
				>
					{feeds.length > 0 &&
						feeds.map((product, index) => {
							return index < 3 ? (
								<NewBlogCard
									data={product}
									key={index}
									title={product.title}
									date={product.created_at}
									image={index == 0 ? First : index == 1 ? Second : Third}
									author={"admin"}
									index={index}
								/>
							) : null;
						})}
				</Box>
			</Box>
		</Box>
	);
};
